<template>
  <v-container>
    <v-layout
      tag="div"
      class="sidebar-submenu-background-overlay"
      v-if="toggleSidebarSubMenu && currentSubLinks && currentSubLinks.length > 0"
      @click="exitSidebarSubmenu()"
    />
    <transition
      name="slide-in-down"
      :enter-active-class="$vuetify.rtl ? 'ktSubMenuSlideInRight' : 'ktSubMenuSlideInLeft'"
      :leave-active-class="$vuetify.rtl ? 'ktSubMenuSlideOutLeft' : 'ktSubMenuSlideOutRight'"
    >
      <div id="sidebar-submenu-container" v-if="toggleSidebarSubMenu && currentSubLinks && currentSubLinks.length > 0">
        <v-list
          dark
          id="sidebar-submenu"
          ref="sidebarSubmenu"
          :style="$vuetify.rtl ? `left:auto; right:${sidebarWidth}px;` : `left:${sidebarWidth}px; right:auto;`"
        >
          <v-list-tile>
            <v-list-tile-title :style="`height:60px; ${$vuetify.rtl ? 'text-align:left;' : 'text-align:right;'}`">
              <kbd class="no-select">ESC</kbd>
              <v-btn fab light small @click="exitSidebarSubmenu()">
                <v-icon dark>close</v-icon>
              </v-btn>
            </v-list-tile-title>
          </v-list-tile>

          <v-divider dark style="border-bottom:1.4px solid rgba(210,200,0, 0.8); margin-bottom:15px;" />

          <div
            v-for="(link, index) in filterSubMenu(currentSubLinks)"
            :key="index"
            class="submenu-links"
            :class="{ 'divider-after': link.dividerAfter }"
          >
            <v-list-tile v-if="!link.isGroup">
              <router-link :to="link.to" tag="a" :class="{ active: setActiveClass(link) }">{{
                $t(link.title)
              }}</router-link>
            </v-list-tile>

            <v-list-group v-else class="first-level-submenu" v-model="link.active">
              <template v-slot:activator>
                <v-list-tile class="sub-group-title">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t(link.title) }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <v-list-tile
                style="background-color: #202020"
                v-for="(link, i) in filterSubMenu(link.groupLinks)"
                :key="i"
                class="submenu-links sub-submenu-links"
              >
                <router-link :to="link.to" tag="a" :class="{ active: setActiveClass(link) }">
                  <span>{{ $t(link.title) }}</span>
                </router-link>
              </v-list-tile>
            </v-list-group>
          </div>
        </v-list>
      </div>
    </transition>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  data() {
    return {
      dividerModified: false
    }
  },
  computed: {
    ...mapGetters({
      sidebarWidth: 'dashboard/sidebarWidth',
      toggleSidebarSubMenu: 'dashboard/toggleSidebarSubMenu',
      currentSubLinks: 'dashboard/currentSubLinks',
      userAuth: 'auth/getAuthUserData'
    })
  },

  watch: {
    currentSubLinks: {
      immediate: false,
      handler() {
        this.fadeInSubMenuLinks()
      }
    },

    $route: {
      immediate: false,
      handler() {
        // if an item in the sidebar got clicked, we close the submenu on route change.
        if (this.toggleSidebarSubMenu) {
          this.exitSidebarSubmenu()
        }
      }
    }
  },

  mounted() {
    document.addEventListener('keyup', e => {
      // if key "ESC" pressed, we close the sidebar submenu
      if (e.keyCode === 27) {
        this.exitSidebarSubmenu()
      }
    })
  },

  methods: {
    ...mapMutations({
      closeSidebarSubMenu: 'dashboard/closeSidebarSubMenu'
    }),

    filterSubMenu(menu) {
      return menu.filter(
        item => this.userAuth.user_id === 1 || (helpers.userHasSidebarPermissions(item.id) && item.id !== 150)
      )
    },

    setActiveClass(link) {
      if (link.to === this.$route.path) {
        return true
      }
    },

    fadeInSubMenuLinks() {
      this.$nextTick(() => {
        let submenuLinks = document.querySelectorAll('#sidebar-submenu .submenu-links')

        if (submenuLinks) {
          submenuLinks.forEach(link => {
            if (this.$vuetify.rtl) {
              link.classList.add('fadeLinkInRight')
            } else {
              link.classList.add('fadeLinkInLeft')
            }
          })
        }
      })
    },

    exitSidebarSubmenu() {
      if (this.toggleSidebarSubMenu) {
        this.closeSidebarSubMenu()
      }
    }
  }
}
</script>

<style scoped>
.sub-submenu-links {
  padding-left: 20px;
}
i.v-icon mdi mdi-chevron-down theme--dark {
  color: aqua !important;
}
#sidebar-submenu-container {
  position: fixed;
  top: 0;
  bottom: 32px;
  background: rgba(10, 10, 10, 0.95);
  overflow-y: scroll;
  overflow-x: hidden;
  width: 426px;
  z-index: 2;
}
#sidebar-submenu {
  position: relative;
  background: transparent;
  z-index: 1000 !important;
  top: 64px;
  min-height: calc(100vh - 97px);
  width: 300px;
}
#sidebar-submenu a,
.sub-group-title {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  min-height: 48px !important;
  line-height: 25px !important;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.001);
  border-left: none;
  border-right: none;
  text-decoration: none;
  text-transform: capitalize;
  /* margin-top: -16px; */
  transition: 0.4s all;
}
#sidebar-submenu a:hover,
#sidebar-submenu a:focus {
  padding-left: 8px;
  padding-right: 8px;
  border-color: rgba(255, 255, 255, 0.3);
  color: rgba(255, 255, 255, 1);
}
.sidebar-submenu-background-overlay {
  background: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
}

.divider-after {
  margin-bottom: 0px;
}
.divider-after::after {
  content: ' ';
  display: block;
  background: rgba(200, 206, 200, 0.3);
  height: 1px;
}
.ktSubMenuSlideInRight {
  animation: subMenuSlideInRight 0.3s ease-in-out;
}
@keyframes subMenuSlideInRight {
  0% {
    transform: translateX(10%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.ktSubMenuSlideOutLeft {
  animation: subMenuSlideOutLeft 0.3s ease-in-out;
}
@keyframes subMenuSlideOutLeft {
  0% {
    opacity: 1;
  }
  100% {
    transform: translateX(10%);
    opacity: 0;
  }
}

.ktSubMenuSlideInLeft {
  animation: subMenuSlideInLeft 0.3s ease-in-out;
}
@keyframes subMenuSlideInLeft {
  0% {
    transform: translateX(-10%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.ktSubMenuSlideOutRight {
  animation: subMenuSlideOutRight 0.3s ease-in-out;
}
@keyframes subMenuSlideOutRight {
  0% {
    opacity: 1;
  }
  100% {
    transform: translateX(-10%);
    opacity: 0;
  }
}

.fadeLinkInLeft {
  animation: ktFadeLinkInLeft 0.5s ease-in-out;
}
@keyframes ktFadeLinkInLeft {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  20% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}

.fadeLinkInRight {
  animation: ktFadeLinkInRight 0.5s ease-in-out;
}
@keyframes ktFadeLinkInRight {
  0% {
    opacity: 0;
    transform: translateX(20px);
  }
  20% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}

@media screen and (max-width: 960px) {
  #sidebar-submenu {
    top: 56px;
    height: calc(100vh - 90px);
  }
}

a.active {
  color: rgb(255, 208, 0) !important;
}
</style>
